var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.79 7.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-1",
    d: "M10.79,1.12a.47.47,0,0,0-.16-.31L9.8.11A.44.44,0,0,0,9.47,0a.49.49,0,0,0-.32.16L5.48,4.41a.12.12,0,0,1-.08,0,.13.13,0,0,1-.09,0L1.64.16A.47.47,0,0,0,1,.11L.16.81A.47.47,0,0,0,0,1.12a.42.42,0,0,0,.11.32L5.05,7.05a.45.45,0,0,0,.34.15.45.45,0,0,0,.35-.15l4.94-5.61A.41.41,0,0,0,10.79,1.12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevronDown.8ea1cfc83df40b13e54b7bb3ecff4b7a.svg";
export { ForwardRef as ReactComponent };